import api from '../lib/api'

const base = (tenantId) => `/manager/notifications/${encodeURIComponent(tenantId)}`

export const listNotifications = (tenantId, params) =>
  api.get(base(tenantId), { params }).then(r => r.data)

export const markNotificationRead = (tenantId, id) =>
  api.post(`${base(tenantId)}/${encodeURIComponent(id)}/read`).then(r => r.data)

export const markAllNotificationsRead = (tenantId) =>
  api.post(`${base(tenantId)}/read-all`).then(r => r.data)

export const deleteNotification = (tenantId, id) =>
  api.delete(`${base(tenantId)}/${encodeURIComponent(id)}`).then(r => r.data)
